/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LabelTemplateListModel { 
    labelTemplateId?: number;
    labelTemplateName?: string | null;
    labelTemplateExt?: string | null;
    locationIdentifier?: string | null;
    locationId?: number;
    statusName?: string | null;
    statusId?: number;
    hasLabelTemplate?: number;
    readonly hasLabelDisplay?: string | null;
}

